<template>
  <div class="row">
    <div class="col-4 pl-1">
      <ListCompanyUnits
        label=""
        name="unitId"
        v-model="serverConfig.unitId"
        placeholder="Unidad"
        :parent-value="serverConfig.divisionId"
        small
        @input="onServerChange"
      />
    </div>
    <div class="col-4 pl-1">
      <ListUser
        label=""
        name="targetUserId"
        small
        v-model="serverConfig.targetUserId"
        placeholder="Usuario"
        @input="onServerChange"
      />
    </div>
    <div class="col-4 pl-1">
      <b-button
        v-has-permission="'ED236'"
        variant="primary"
        size="sm"
        @click="clearFilterByUser()"
      >
        Global
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

import ListCompanyUnits from '@/febos/chile/lists/components/ListCompanyUnits';
import ListUser from '@/febos/chile/lists/components/ListUser';
import { FILTER_SERVER_MAPPER_DASHBOARD } from '@/febos/chile/approvals/vistas/dashboard/filters/config';

export default {
  components: { ListCompanyUnits, ListUser },
  props: {
    periodos: {
      type: Array,
      required: false
    },
    hasQueryFilters: {
      type: Boolean,
      default: false
    },
    clearQueryFilters: {
      type: Function
    }
  },
  data() {
    return {
      onTheFlyConfig: {
        name: ''
      },
      serverConfig: {
        divisionId: '',
        unitId: '',
        targetUserId: ''
      }
    };
  },
  watch: {

  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores
    })
  },
  methods: {
    onServerChange() {
      const filters = Object.entries(this.serverConfig)
        .filter(([, value]) => !!value)
        .map(([key, value]) => (
          `${FILTER_SERVER_MAPPER_DASHBOARD[key]}:${value}`
        ))
        .join('|');
      this.$emit('on-server-filters-change', filters);
    },
    clearFilterByUser() {
      this.serverConfig = {
        ...this.serverConfig,
        targetUserId: ''
      };
      this.onServerChange();
    }
  },
  created() {
    this.serverConfig.targetUserId = this.currentUser.id;
    this.onServerChange();
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}

.scroll-options {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
